import React, { Fragment, useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import Logo from "./../../assets/Marquis-Developers-Logo-SVG.svg";
import Form from "react-bootstrap/Form";
import { HashLink as Link } from "react-router-hash-link";
import ReCAPTCHA from "react-google-recaptcha";

import {
  FaTiktok,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { TfiYoutube } from "react-icons/tfi";
import LazyLoad from "react-lazyload";
import marquisLogo from "./../../assets/marquis-logo.svg";
import sidefixedicon1 from "./../../assets/side-fixed-icon1.svg";
import sidefixedicon2 from "./../../assets/side-fixed-icon2.svg";
import sidefixedicon3 from "./../../assets/side-fixed-icon3.svg";
import sidefixedicon4 from "./../../assets/side-fixed-icon4.svg";
import AgentSideImg from "./../../assets/img/become-agent/agent-form-img.jpg";
import * as apiUrl from "../../apiUrl";

function Footer() {
  const sectionRefs = useRef({});

  const [footerMenu, setFooterMenu] = useState([]);
  const [footerSection, setfooterSection] = useState([]);
  const [footerBottomSection, setfooterBottomSection] = useState([]);
  const [socialMediaSection, setsocialMediaSection] = useState([]);
  const [footerLogoSection, setfooterLogoSection] = useState([]);

  const [footerformData, setFooterFormData] = useState({
    email_footer: "",
  });
  const [footererrors, setFooterErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  // Registre Form Validation and Submission
  const [RegistercaptchaToken, setRegisterCaptchaToken] = useState(null);
  const [RegisterformData, setRegisterFormData] = useState({
    registerformname: "",
    registerformemail: "",
    registerformmobile: "",
    registerformproperty: "",
    registerformcomment: "",
  });
  const [registererrors, setregisterErrors] = useState({});
  const captchaRef = useRef(null);

  const validateRegisterField = (fieldName, value) => {
    const namePattern = /^[A-Za-z\s]+$/;
    const mobilePattern = /^[0-9]+$/;
    let error = "";

    switch (fieldName) {
      case "registerformname":
        if (!value) error = "Please enter your Name.";
        else if (!namePattern.test(value))
          error = "First Name should only contain letters.";
        break;

      case "registerformemail":
        if (!value) error = "Please enter your Email.";
        else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
        break;

      case "registerformmobile":
        if (!value) error = "Please enter your Mobile Number.";
        else if (!mobilePattern.test(value) || value.length < 10)
          error =
            "Mobile Number should only contain numbers and be at least 10 digits.";
        break;

      case "registerformcomment":
        if (!value) error = "Please enter a Message.";
        break;

      case "registerformproperty":
        if (!value) error = "Please select a Property.";
        break;

      case "RegistercaptchaToken":
        if (!value) error = "Please Select the CAPTCHA.";
        break;

      default:
        break;
    }

    setregisterErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const handleRegisterBlur = (e) => {
    const { name, value } = e.target;
    validateRegisterField(name, value);
  };

  const handleRegisterCaptchaChange = (token) => {
    setRegisterCaptchaToken(token);
  };

  const handleRegisterNameChange = (e) => {
    const { name, value } = e.target;
    const namePattern = /^[A-Za-z\s]*$/;

    if (namePattern.test(value)) {
      setRegisterFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleRegisterMobileChange = (e) => {
    const { value } = e.target;
    const mobilePattern = /^[0-9]*$/;

    if (mobilePattern.test(value)) {
      setRegisterFormData((prev) => ({ ...prev, registerformmobile: value }));
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    let isValid = true;
    Object.keys(RegisterformData).forEach((key) => {
      validateRegisterField(key, RegisterformData[key]);
      if (registererrors[key]) {
        isValid = false;
      }
    });

    // Validate reCAPTCHA last
    if (!RegisterformData.RegistercaptchaToken) {
      setregisterErrors((prev) => ({
        ...prev,
        RegistercaptchaToken: "Please Select the CAPTCHA.",
      }));
      isValid = false;
    }

    if (!isValid) return;

    try {
      const RegisterformDataObj = new FormData();
      RegisterformDataObj.append("name", RegisterformData.registerformname);
      RegisterformDataObj.append(
        "property",
        RegisterformData.registerformproperty
      );
      RegisterformDataObj.append("email", RegisterformData.registerformemail);
      RegisterformDataObj.append("mobile", RegisterformData.registerformmobile);
      RegisterformDataObj.append(
        "comment",
        RegisterformData.registerformcomment
      );
      RegisterformDataObj.append(
        "RegistercaptchaToken",
        RegisterformData.RegistercaptchaToken
      );

      const response = await fetch(apiUrl.apiUrl + `/api/register/submit`, {
        method: "POST",
        body: RegisterformDataObj,
      });
      const result = await response.json();
      if (result.success) {
        setShowModal(true);
        setRegisterFormData({
          registerformname: "",
          registerformproperty: "",
          registerformemail: "",
          registerformmobile: "",
          registerformcomment: "",
          RegistercaptchaToken: "",
        });

        if (captchaRef.current) {
          captchaRef.current.reset();
        }

        setRegisterCaptchaToken(null);
        localStorage.removeItem("RegistercaptchaToken");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleRegisterChange = (e) =>
    setRegisterFormData({
      ...RegisterformData,
      [e.target.name]: e.target.value,
    });

  //Function to go to a specific section by ID
  // const goToSection = (id) => {
  //   if (sectionRefs.current[id]) {
  //     sectionRefs.current[id].scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // };

  const goToSection = (id) => {
    if (sectionRefs.current[id]) {
      // Scroll to the section
      sectionRefs.current[id].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Update the URL hash without reloading
      window.history.replaceState(null, "", `#${id}`);
    }
  };

  useEffect(() => {
    const fetchFooterMenu = async () => {
      try {
        // Footer Menu
        const response = await fetch(apiUrl.apiUrl + `/api/footer/menu`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setFooterMenu(data);

        // Footer Section
        const footersectionresponse = await fetch(
          apiUrl.apiUrl + `/api/footer/section`
        );
        if (!footersectionresponse.ok) {
          throw new Error("Failed to footer section data");
        }
        const footersectiondata = await footersectionresponse.json();
        setfooterSection(footersectiondata);

        // Footer Bottom Section
        const footerbottomresponse = await fetch(
          apiUrl.apiUrl + `/api/footer-bottom/section`
        );
        if (!footerbottomresponse.ok) {
          throw new Error("Failed to footer bottom section data");
        }
        const footerbottomdata = await footerbottomresponse.json();
        setfooterBottomSection(footerbottomdata);

        // Footer Social Media Section
        const socialmediaresponse = await fetch(
          apiUrl.apiUrl + `/api/social-media/section`
        );
        if (!socialmediaresponse.ok) {
          throw new Error("Failed to footer social section data");
        }
        const socialmediadata = await socialmediaresponse.json();
        setsocialMediaSection(socialmediadata);

        // Logos section
        const logoresponse = await fetch(apiUrl.apiUrl + `/api/logos/section`);
        if (!logoresponse.ok) {
          throw new Error("Failed to logo section data");
        }
        const logodata = await logoresponse.json();
        const footerLogo = logodata.filter(
          (logo) => logo.logo_title === "Footer Logo"
        )[0];

        // Set the footer logo section state
        setfooterLogoSection(footerLogo);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchFooterMenu();
  }, []);

  const phones = footerSection.phone ? JSON.parse(footerSection.phone) : [];

  const validateField = (fieldName, value) => {
    let error = "";

    switch (fieldName) {
      case "email_footer":
        if (!value) error = "Please enter your Email.";
        else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
        break;

      default:
        break;
    }

    setFooterErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!validateForm()) return;

    Object.keys(footerformData).forEach((key) => {
      validateField(key, footerformData[key]);
    });

    if (Object.values(footererrors).some((error) => error)) {
      setFooterErrors((prev) => ({
        ...prev,
        // captchaToken: "Please Select the CAPTCHA.",
      }));
      return;
    }

    try {
      const footerformDataObj = new FormData();
      footerformDataObj.append("email_footer", footerformData.email_footer);

      const response = await fetch(apiUrl.apiUrl + `/api/footer/submit`, {
        method: "POST",
        body: footerformDataObj,
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const result = await response.json(); // JSON parsing
      if (result.success) {
        setShowModal(true);
        setFooterFormData({ email_footer: "" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleChange = (e) =>
    setFooterFormData({ ...footerformData, [e.target.name]: e.target.value });

  const handleCloseModal = () => setShowModal(false);

  const [show, setShow] = useState(false);

  const handleCloseenquiry = () => setShow(false);
  const handleShowenquiry = () => setShow(true);
  return (
    <Fragment>
      <section className="footer-top-stripe-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5">
              <h2 className="common-head goldenColor">Visit Our Office</h2>
              {/* <h4 className="common-head goldenColor">Don’t wait any longer</h4> */}
              {/* <p className="common-para">Visit us in our office</p> */}
              <div
                onClick={handleShowenquiry}
                className="marquis-golden-button"
              >
                Book an Appointment
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="marquis-new-footer">
        <Container fluid className="footerDiv common-para">
          <Row className="flex-center">
            <Col md={12}>
              <div className="centerFootdiv">
                {/* AdderDiv*/}
                <Row className="footerTopdiv flex-center">
                  <Col md={3} className="padding-zero">
                    <Link to="/home">
                      {" "}
                      {footerLogoSection && (
                        <img
                          src={apiUrl.apiUrl + `/` + footerLogoSection.logo}
                          alt={footerLogoSection.logo_title}
                        />
                      )}{" "}
                    </Link>
                  </Col>
                  <Col md={4} className=" flex-end">

                  </Col>
                  <Col md={5} className="padding-zero">

                  </Col>

                </Row>
                {/* Footer Links Div */}
                <Row className="borderTop footerLinks justify-content-xl-around">
                  <Col md="5" className="footeraddress-social-media">

                    <div className="footer-contact-div">
                      <h5 className="common-head goldenColor">
                        {" "}
                        {footerSection.sub_title}
                      </h5>
                      <p className="common-para">
                        Office: {footerSection.address} <br />
                        Phone:{" "}
                        {phones.length > 0 && (
                          <span>
                            {phones.map((phone, index) => (
                              <span key={index}>
                                <a href={`tel:${phone}`}>{phone}</a>
                                {index === 1 && phones.length > 2 && <br />}
                                {index < phones.length - 1 && index !== 1 && (
                                  <span>, </span>
                                )}
                              </span>
                            ))}
                          </span>
                        )}
                        <br />
                        Email:{" "}
                        <a href={`mailto:${footerSection.mailid}`}>
                          {footerSection.mailid}
                        </a>
                      </p>
                    </div>
                    <Row className="social-icons-row">
                      <Col md={12} className="social-icons-col">
                        <div className="social-icons-div">
                          <a
                            href={socialMediaSection.tiktok_link}
                            target={"_blank"}
                          >
                            <FaTiktok />
                          </a>

                          <a
                            href={socialMediaSection.youtube_link}
                            target={"_blank"}
                          >
                            <TfiYoutube />
                          </a>

                          <a
                            href={socialMediaSection.insta_link}
                            target={"_blank"}
                          >
                            <FaInstagram />
                          </a>

                          <a
                            href={socialMediaSection.facebook_link}
                            target={"_blank"}
                          >
                            <FaFacebookF />
                          </a>

                          <a
                            href={socialMediaSection.linkedin_link}
                            target={"_blank"}
                          >
                            <FaLinkedinIn />
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col md="7" className="padding-zero footerlinks-col-div">
                    <Row className="justify-content-xl-between">
                      {footerMenu.map((section) => (
                        <Col key={section.id} md={3} className="padding-zero">
                          <h4 className="footer-small-heading">
                            {section.slug === "/" ? (
                              section.menu_text
                            ) : (
                              <Link
                                smooth
                                to={section.slug}
                                onClick={() => goToSection(section.id)}
                              >
                                {section.menu_text}
                              </Link>
                            )}
                          </h4>
                          <ul className="footer-links-list">
                            {section.children &&
                              section.children
                                .sort((a, b) => a.order - b.order)
                                .map((child) => (
                                  <li key={child.id}>
                                    <Link
                                      smooth
                                      to={child.slug}
                                      onClick={() => goToSection(child.id)}
                                    >
                                      {child.menu_text}
                                    </Link>
                                  </li>
                                ))}
                          </ul>
                        </Col>
                      ))}
                    </Row>


                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="copyRightDiv">
            <Col md={6} className="text-left marquis-footer-left">
              <Link
                className="links leftborder-links"
                to={footerBottomSection.terms_conditions_link}
              >
                {" "}
                <p> {footerBottomSection.terms_conditions_text} </p>
              </Link>
              <Link
                className="links leftborder-links"
                to={footerBottomSection.privacy_policy_link}
              >
                <p> {footerBottomSection.privacy_policy_text}</p>
              </Link>
            </Col>
            <Col md={6} className="text-right marquis-footer-right">
              <p className="goldenColor">
                Website By{" "}
                <a href={footerBottomSection.website_by_link} target={"_blank"}>
                  {footerBottomSection.website_by_text}
                </a>
                . {footerBottomSection.rights_text}.
              </p>
            </Col>
          </Row>
        </Container>
        <div className="connect-icons-ctrl">
          <Button onClick={handleShowenquiry} className="connect-icons">
            {" "}
            <img
              src={sidefixedicon1}
              className="img-fluid"
              alt="side-icon-img"
            />{" "}
            Enquire
          </Button>
          <Link to="https://wa.me/971561689493" className="connect-icons" target="_blank" rel="noopener noreferrer">
            {" "}
            <img
              src={sidefixedicon2}
              className="img-fluid"
              alt="side-icon-img"
            />{" "}
            whatsapp
          </Link>
          {/* <a href="#" className="connect-icons">
            {" "}
            <img
              src={sidefixedicon3}
              className="img-fluid"
              alt="side-icon-img"
            />{" "}
            chat
          </a> */}
          <Link to="tel:+971 800 6277847" className="connect-icons">
            {" "}
            <img
              src={sidefixedicon4}
              className="img-fluid"
              alt="side-icon-img"
            />{" "}
            call
          </Link>
        </div>
      </section>

      {/* Modal Component */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        className="response-popup"
      >
        <Modal.Header>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Form Submitted Successfully!</Modal.Body>
        <Modal.Footer>
          <button className="marquis-grey-button" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* Enquiry Button Modal */}
      <Modal
        show={show}
        onHide={handleCloseenquiry}
        centered
        size="lg"
        className="enquiry-form-modal"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <div className="enquiry-form-modal-div">
            <Container fluid>
              <Row className="flex-center career-inner-desc-row">
                <Col md={6} className="padding-zero">
                  <div className="career-inner-content-div">
                    <h2 className="common-head goldenColor">Register Now?</h2>
                    <p className="common-para">
                      Think you have what it takes? Join Marquis and turn
                      ambition into impact in the world.
                    </p>
                    <img
                      src={AgentSideImg}
                      className="img-fluid career-side-img"
                      alt="agentsideimg"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="career-inner-form-div">
                    <Form onSubmit={handleRegisterSubmit}>
                      <Row>
                        <Form.Group
                          className="col-md-12 mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          {/* <Form.Control
                            type="text"
                            name="name"
                            placeholder="Name"
                          /> */}
                          <Form.Control
                            type="text"
                            name="registerformname"
                            placeholder="Name"
                            value={RegisterformData.registerformname}
                            onChange={handleRegisterNameChange}
                            onBlur={handleRegisterBlur}
                          />
                          {registererrors.registerformname && (
                            <p className="error">
                              {registererrors.registerformname}
                            </p>
                          )}
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          className="col-md-12 mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          {/* <Form.Control
                            type="text"
                            name="name"
                            placeholder="Email"
                          /> */}

                          <Form.Control
                            type="text"
                            name="registerformemail"
                            placeholder="Email"
                            value={RegisterformData.registerformemail}
                            onChange={handleRegisterChange}
                            onBlur={handleRegisterBlur}
                          />
                          {registererrors.registerformemail && (
                            <p className="error">
                              {registererrors.registerformemail}
                            </p>
                          )}

                          {/* <p className="error">Error Message</p> */}
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          className="col-md-12 mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          {/* <Form.Control
                            type="text"
                            name="name"
                            placeholder="Mobile Number"
                          /> */}

                          <Form.Control
                            type="text"
                            name="registerformmobile"
                            placeholder="Mobile Number"
                            value={RegisterformData.registerformmobile}
                            onChange={handleRegisterMobileChange}
                            onBlur={handleRegisterBlur}
                          />
                          {registererrors.registerformmobile && (
                            <p className="error">
                              {registererrors.registerformmobile}
                            </p>
                          )}
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <Form.Group>
                            <Form.Select
                              className="mb-3 form-control"
                              name="registerformproperty"
                              value={RegisterformData.registerformproperty}
                              onChange={handleRegisterChange}
                              onBlur={handleRegisterBlur}
                            >
                              <option value="">Property</option>
                              {/* <option value="Marquis Horizon">Marquis Horizon</option> */}
                              <option value="Marquis One">Marquis One</option>
                              <option value="Marquis Vista">
                                Marquis Vista
                              </option>
                              <option value="Marquis Insignia">
                                Marquis Insignia
                              </option>
                              <option value="Marquis Elegance">
                                Marquis Elegance
                              </option>
                              <option value="Marquis Galleria">
                                Marquis Galleria
                              </option>
                              <option value="Marquis Signature">
                                Marquis Signature
                              </option>
                            </Form.Select>
                            {registererrors.registerformproperty && (
                              <p className="error">
                                {registererrors.registerformproperty}
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Form.Group
                          className="col-md-12 mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >

                          <Form.Control
                            as="textarea"
                            placeholder="Drop Your Message"
                            name="registerformcomment"
                            value={RegisterformData.registerformcomment}
                            onChange={handleRegisterChange}
                            onBlur={handleRegisterBlur}
                            rows={3}
                          />
                          {registererrors.registerformcomment && (
                            <p className="error">
                              {registererrors.registerformcomment}
                            </p>
                          )}
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-12 mb-3">
                          <ReCAPTCHA
                            className="gcaptcha-size"
                            sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"
                            ref={captchaRef}
                            onChange={(value) => {
                              setRegisterFormData((prevData) => ({
                                ...prevData,
                                RegistercaptchaToken: value,
                              }));
                              validateRegisterField("RegistercaptchaToken", value);
                            }}
                          />

                          {registererrors.RegistercaptchaToken && (
                            <p className="error gcaptcha-error-msg">
                              {registererrors.RegistercaptchaToken}
                            </p>
                          )}
                        </Form.Group>
                      </Row>

                      <Row className="mt-2 form-btn">
                        <Col md={12}>
                          <button type="submit" className="marquis-grey-button">
                            Submit
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                  <Row className="mt-2 form-btn">
                    <Col md={12}>
                      <div className="enquiry-form-bottom-logo">
                        <img
                          className="img-fluid"
                          src={marquisLogo}
                          alt="marquislogo-img"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </Modal.Body>

      </Modal>
    </Fragment>
  );
}

export default Footer;
